import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import MaterialTable from 'material-table';
import Select from 'react-select'

// reactstrap components
import { Button, Card, CardHeader, CardBody, FormGroup, Form, Input, Row, Col, Container, UncontrolledTooltip, Tooltip, CardText } from "reactstrap";
import InputPDF from "../../../components/Input/InputPDF.jsx";

//helpers
import { isValidDate } from "../../../helpers/valid.js";

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// services
import { api_GET, api_POST } from "../../../services/api_service.js";
import { showMessage, showQuestion } from "../../../services/message.js";

import { EnviaProtocoloTransportadorVeiculo, EnviaRequerimentoTransportadorVeiculo } from "../../../services/protocolo_transportador_service.js";
import { formateDateApi } from "../../../helpers/formats.js";

//Context
import { useAuth } from "../../../context/auth.js";

export default function Veiculos({ item, tipoCadastro, permiteManutencao, totalVeiculos, handleProximoStep, handleStepAnterior }) {
    const { session, setLoading, setupSistema } = useAuth();

    const { register, handleSubmit, errors, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [permiteEditar, set_permiteEditar] = React.useState(true);

    const [registro, set_registro] = React.useState(null);

    const [veiculos, set_veiculos] = React.useState([]);

    const [tooltipOpen, setTooltipOpen] = React.useState(false);
    const toggleTip = () => setTooltipOpen(!tooltipOpen);

    useEffect(() => {
        LoadTiposVeiculo();

        if (session != null && session.tipoAcesso == "AreaRestrita")
            set_permiteEditar(false);

        if (tipoCadastro == "Protocolo")
            loadItemProtocolo();
        else if (tipoCadastro == "Requerimento")
            loadItemRequerimento();
    }, []);

    const loadItemProtocolo = () => {
        set_registro(item);
        if (item != null && item.protocoloTransportador[0].protocoloTransportadorVeiculo != null) {
            set_veiculos(item.protocoloTransportador[0].protocoloTransportadorVeiculo);
        }

        let _actionRenavam = actions;
        _actionRenavam.push({
            icon: 'description',
            tooltip: 'Visualizar Renavam',
            onClick: (event, rowData) => handleVisualizaRENAVAM(rowData)
        });

        set_actions(_actionRenavam);
    }

    const loadItemRequerimento = () => {
        set_registro(item);
        if (item != null && item.requerimentoTransportadorVeiculo != null) {
            set_veiculos(item.requerimentoTransportadorVeiculo);
        }

        if (tipoCadastro == "Requerimento" && (item.setupSolicitacaoAcao.acao !== "Alteração" && item.setupSolicitacaoAcao.acao !== "Renovação de Veículo")) {
            let _action = actions;
            _action.push({
                icon: 'delete',
                tooltip: 'Remover Veículo',
                onClick: (event, rowData) => handleRemove(rowData)
            });

            set_actions(_action);
        }

        if (item.setupSolicitacaoAcao.acao !== "Alteração") {
            let _actionRenavam = actions;
            _actionRenavam.push({
                icon: 'description',
                tooltip: 'Visualizar Renavam',
                onClick: (event, rowData) => handleVisualizaRENAVAM(rowData)
            });

            set_actions(_actionRenavam);
        }

    }

    // Material-Table > Actions
    const [actions, set_actions] = useState([
        {
            icon: 'edit',
            tooltip: 'Editar Registro',
            onClick: (event, rowData) => handleEdit(rowData)
        },
    ]);

    // Placa
    const handleChangePlaca = (e) => {
        let result = e.target.value.replace(/[^a-zà-ú0-9]/gi, '');
        setValue("placa", result);
    }

    // Data Vigência
    const handleDataVigencia = (event) => {
        let input_date = event.target.value;

        if (input_date != "" || input_date.length > 0) {
            if (!isValidDate(input_date)) {
                showMessage("Aviso", "Data informada é inválida.", 'warning', null);
                return;
            }
        }
    }

    // Tipo Veículo
    const [optionsTipoVeiculo, set_optionsTipoVeiculo] = React.useState([])

    const LoadTiposVeiculo = () => {
        if ((tipoCadastro == "Requerimento" && item.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RGG") ||
            (tipoCadastro == "Protocolo" && item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla == "RGG")) {
            api_GET('TipoImplemento')
                .then(result => {
                    let tipos = result.data.map((m, key) => ({
                        label: m.descricao,
                        value: m.descricao
                    }));
                    set_optionsTipoVeiculo(tipos);
                })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        } else {
            set_optionsTipoVeiculo([
                { label: "Basculante", value: "Basculante" },
                { label: "Caminhão Toco", value: "Caminhão Toco" },
                { label: "Carreta", value: "Carreta" },
                { label: "Cavalo Mecânico", value: "Cavalo Mecânico" },
                { label: "Poliguindaste", value: "Poliguindaste" },
                { label: "Reboque", value: "Reboque" },
                { label: "Roll-on Roll-off", value: "Roll-on Roll-off" },
                { label: "Veículo Urbano de Carga", value: "Veículo Urbano de Carga" },
                { label: "Caminhão Carroceria", value: "Caminhão Carroceria" },
                { label: "Compactador", value: "Compactador" }
            ]);
        }
    }

    const [tipoVeiculo, set_tipoVeiculo] = React.useState(null);
    const handleTipoVeiculo = (value) => {
        set_tipoVeiculo(value);
        setValue("tipoVeiculo", value, true);
        clearErrors("tipoVeiculo");

        if ((tipoCadastro == "Requerimento" && item.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RGG") ||
            (tipoCadastro == "Protocolo" && item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla == "RGG")) {
            set_modalidades([]);
            loadModalidades(value);
        }
    }

    //Modalidades 
    const [modalidades, set_modalidades] = useState([]);
    const [optionsModalidades, set_OptionsModalidades] = useState([]);

    const loadModalidades = (descricao) => {
        api_GET(`Modalidade/GetModalidades/` + descricao)
            .then(result => {
                let tipos = result.data.map((m, key) => ({
                    label: m.descricao,
                    value: m.descricao
                }));
                set_OptionsModalidades(tipos);
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleModalidades = event => {
        set_modalidades(event);
    }


    // pegar o status quando for editar
    const [veiculoStatus, setVeiculoStatus] = useState(null)
    const handleStatusVeiculo = (value) => {
        setVeiculoStatus(value)
        setValue("status", value, true);
        clearErrors("status");
    }

    // Arquivo Renavam
    const [file_renavam, set_file_renavam] = React.useState(null);
    const handleFileRenavam = (_file, callback) => {
        if (_file == null) {
            showMessage("Aviso", "Não foi possível concluir o anexo do arquivo. Arquivo RENAVAM não informado. Apresente o arquivo RENAVAM do veículo.", 'error', null);
            return;
        }
        set_file_renavam(_file);
        callback();
    }

    // Arquivo Inmetro
    const [file_inmetro, set_file_inmetro] = React.useState(null);
    const handleFileInmetro = (_file, callback) => {
        if (_file == null) {
            showMessage("Aviso", "Não foi possível concluir o anexo do arquivo. Arquivo INMETRO não informado. Apresente o arquivo INMETRO do veículo.", 'error', null);
            return;
        }
        set_file_inmetro(_file);
        callback();
    }

    // Arquivo Comprovante Tara
    const [file_comprovantetara, set_file_comprovantetara] = React.useState(null);
    const handleFileComprovanteTara = (_file, callback) => {
        if (_file == null) {
            showMessage("Aviso", "Não foi possível concluir o anexo do arquivo. Arquivo COMPROVANTE DE TARA não informado. Apresente o arquivo COMPROVANTE DE TARA do veículo.", 'error', null);
            return;
        }
        set_file_comprovantetara(_file);
        callback();
    }

    // Arquivo Comodato
    const [file_comodato, set_file_comodato] = React.useState(null);
    const handleFileComodato = (_file, callback) => {
        if (_file == null) {
            showMessage("Aviso", "Não foi possível concluir o anexo do arquivo. Arquivo COMODATO não informado. Apresente o arquivo COMODATO do veículo.", 'error', null);
            return;
        }
        set_file_comodato(_file);
        callback();
    }
    const loadInputComodato = () => {
        if ((tipoCadastro == "Requerimento" && item.setupSolicitacaoAcao.setupSolicitacao.pessoa != "Física")
            || (tipoCadastro == "Protocolo" && item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.pessoa != "Física")) {
            return <Col md="3" lg="3">
                <FormGroup>
                    <b><p style={{ color: "#888" }}> Comodato <a href="#" id="questionComodato"><i className="fas fa-question-circle"></i></a>
                        <UncontrolledTooltip target="questionComodato" placement="top">Obrigatório para veículos locados. Contrato de aluguel do veículo</UncontrolledTooltip>
                    </p></b>
                    <InputPDF name="arquivoComodato"
                        image={file_comodato}
                        height="3rem"
                        width="3rem"
                        documento_id={0} handlefile={handleFileComodato}>
                    </InputPDF>
                </FormGroup>
            </Col>
        }
    }

    // Veiculo Proprietário / Locado
    const [proprietarioOuLocado, set_proprietarioOuLocado] = React.useState(null);
    const [options_proprietarioOuLocado] = React.useState([
        { value: "Proprietário", label: "Proprietário" },
        { value: "Locado", label: "Locado" },
    ]);
    const handleproprietarioOuLocado = (value) => {
        set_proprietarioOuLocado(value);
        setValue("proprietarioOuLocado", value, true);
    }

    const handleVisualizaRENAVAM = (rowData) => {
        if (rowData.arquivoRenavam != null && rowData.arquivoRenavam.length > 0) {
            window.open(setupSistema?.caminhoVirtual + rowData.arquivoRenavam, '_blank');
        }
        else {
            showMessage("Aviso", "O veículo selecionado não possui o RENAVAM anexado", 'warning', null);
            return;
        }
    }

    const [rowEdit, set_rowEdit] = React.useState(null);
    const handleEdit = (rowData) => {
        set_rowEdit(rowData);

        if ((tipoCadastro == "Requerimento" && item?.setupSolicitacaoAcao?.acao !== "Renovação de Veículo") || (tipoCadastro == "Protocolo" && !item?.setupSolicitacaoAcao?.acao)) {
            setValue("placa", rowData.placa);
            setValue("marca", rowData.marca);
            setValue("status", rowData.status)
            set_tipoVeiculo(rowData.tipo);
            setValue("tipoVeiculo", rowData.tipo, true);
            setValue("anoFabricacao", rowData.anoFabricacao);
            setValue("capacidadeCarga", rowData.capacidadeCarga);
            setValue("tara", rowData.tara);
            setValue("renavam", rowData.numeroRenavam);
            setValue("cor", rowData.cor);
            setValue("anoFabricacaoEquipamento", rowData.anoFabricacaoEquipamento);
            set_proprietarioOuLocado(rowData.proprietarioOuLocado);
            setValue("proprietarioOuLocado", rowData.proprietarioOuLocado, true);
            setValue("volume", rowData.volume);
            setVeiculoStatus(rowData.status);
            if (tipoCadastro == "Requerimento") {
                if (rowData.requerimentoTransportadorVeiculoModalidade) {
                    let _modalidades = rowData.requerimentoTransportadorVeiculoModalidade.map((m, key) => ({
                        label: m.modalidade,
                        value: m.modalidade
                    }))
                    set_modalidades(_modalidades);
                }
            } else if (tipoCadastro == "Protocolo") {
                let _modalidades = rowData.protocoloTransportadorVeiculoModalidades.map((m, key) => ({
                    label: m.modalidade,
                    value: m.modalidade
                }))
                set_modalidades(_modalidades);
            }


            loadModalidades(rowData.tipo);

            if (rowData.dataVistoria != null)
                setValue("dataVistoria", formateDateApi(rowData.dataVistoria));
            else
                setValue("dataVistoria", "");

            if (rowData.dataValidadeVistoria != null)
                setValue("dataValidadeVistoria", formateDateApi(rowData.dataValidadeVistoria));
            else
                setValue("dataValidadeVistoria", "");

            if (rowData.arquivoRenavam != null) {
                set_file_renavam({
                    name: rowData.arquivoRenavam,
                    base64: null,
                    documento_Id: 0
                });
            }

            if (rowData.arquivoInspecaoInmetro != null) {
                set_file_inmetro({
                    name: rowData.arquivoInspecaoInmetro,
                    base64: null,
                    documento_Id: 0
                });
            }

            if (rowData.arquivoComprovanteTara != null) {
                set_file_comprovantetara({
                    name: rowData.arquivoComprovanteTara,
                    base64: null,
                    documento_Id: 0
                });
            }

            if (rowData.arquivoComodato != null) {
                set_file_comodato({
                    name: rowData.arquivoComodato,
                    base64: null,
                    documento_Id: 0
                });
            }
        } else {
            setValue("placa", rowData.placa);
        }
    }

    const handleRemove = (rowData) => {
        if (!permiteManutencao && tipoCadastro == "Protocolo") {
            showMessage("Aviso", "Não permitida a manutenção do cadastro.", 'error', null);
            return;
        }

        showQuestion('Atenção', 'Deseja remover este veículo?', 'question', function (result) {
            if (result) {
                setLoading(true);
                api_POST('requerimentoTransportador/PostRemoverVeiculoRequerimento/' + rowData.requerimentoTransportadorVeiculo_Id)
                    .then(result => { showMessage("Aviso", "Veículo removido com sucesso!", 'success', function () { handleReturnRemove(rowData.requerimento_Id) }) })
                    .catch(err => showMessage("Aviso", err.message, 'error', null))
                    .finally(() => setLoading(false));
            }
        })
    }
    const handleReturnRemove = (reloadId) => {
        setLoading(true);

        api_GET('requerimentoTransportador/GetVeiculosRequerimento/' + reloadId)
            .then(result => set_veiculos(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const onSubmit = (data) => {
        if (item.setupSolicitacaoAcaoNovoCadastro) {
            if (rowEdit == null &&
                (item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.pessoa == "Física") &&
                (totalVeiculos + veiculos.filter(x => x.status == "Ativo").length >= 2)
            ) {
                showMessage("Aviso", "Você não pode ter mais que dois veículos como Pessoa Física ou MEI!", 'error', null);
                return;
            }
        } else {
            if (rowEdit == null &&
                (item.setupSolicitacaoAcao.setupSolicitacao.pessoa == "Física") &&
                (totalVeiculos + veiculos.filter(x => x.status == "Ativo").length >= 2)
            ) {
                showMessage("Aviso", "Você não pode ter mais que dois veículos como Pessoa Física ou MEI!", 'error', null);
                return;
            }
        }

        if (veiculos.length == 2 &&
            rowEdit == null &&
            tipoCadastro == "Requerimento" &&
            item.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla === "RCC" &&
            item.setupSolicitacaoAcao.setupSolicitacao.pessoa === "Jurídica - MEI"
        ) {
            showMessage("Aviso", `Você só pode incluir até 2 veículo no requerimento`, 'warning', null);
            return;
        }

        if (veiculos.length == 1 &&
            rowEdit == null &&
            tipoCadastro == "Requerimento" &&
            item.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RGG" &&
            (item.setupSolicitacaoAcao.acao == "Inclusão" || item.setupSolicitacaoAcao.acao == "Renovação de Veículo")
        ) {
            showMessage("Aviso", `Você só pode incluir um veículo no requerimento de ${item.setupSolicitacaoAcao.acao}`, 'warning', null);
            return;
        }

        if (rowEdit == null && tipoCadastro == "Requerimento" && item.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RGG" && item.setupSolicitacaoAcao.acao == "Renovação de Veículo"
        ) {
            showMessage("Aviso", `Selecione um veículo da lista. A inserção manual não é permitida no requerimento de ${item.setupSolicitacaoAcao.acao}`, 'error', null);
            return;
        }

        if (rowEdit == null && veiculos.filter(f => f.placa == data.placa || f.numeroRenavam == data.renavam).length > 0) {
            showMessage("Aviso", "Já existe um veículo com esta placa/renavam!", 'error', null);
            return;
        }

        if (data.placa.replace("-", "").length != 7) {
            showMessage("Aviso", "Placa Inválida!", 'error', null);
            return;
        }

        if ((session == null || (session && session.tipoAcesso == "Protocolo")) && (file_renavam == null || file_inmetro == null)) {
            showMessage("Aviso", "Arquivos .pdf obrigatórios não informados: Arquivo Renavam; Inspeção Inmetro.", 'error', null);
            return;
        }

        if ((tipoCadastro == "Requerimento" && item.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RGG" && modalidades.length == 0)
            || (tipoCadastro == "Protocolo" && item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla == "RGG" && modalidades.length == 0)) {
            showMessage("Aviso", "Obrigatório selecionar pelo menos uma modalidade!", 'error', null);
            return;
        }

        if (!tipoVeiculo) {
            showMessage("Aviso", "Obrigatório selecionar o tipo de veículo!", 'error', null);
            return;
        }

        setLoading(true);
        if (permiteManutencao && tipoCadastro == "Protocolo") {
            let json = carregaJsonProtocolo(data);
            EnviaProtocoloTransportadorVeiculo(json, confirmaAddVeiculo)
        }
        else if (tipoCadastro == "Requerimento") {
            let json = carregaJsonRequerimento(data);
            EnviaRequerimentoTransportadorVeiculo(json, confirmaAddVeiculo)
        }
    }
    const carregaJsonProtocolo = (data) => {
        let protocoloTransportadorVeiculoModalidade = [];
        modalidades.map(m => {
            protocoloTransportadorVeiculoModalidade.push({
                protocoloTransportadorVeiculoModalidade_Id: 0,
                protocoloTransportadorVeiculo_Id: rowEdit == null ? 0 : rowEdit.protocoloTransportadorVeiculo_Id,
                modalidade: m.value
            });
        })

        let json_submit = {
            protocoloTransportadorVeiculo_Id: rowEdit == null ? 0 : rowEdit.protocoloTransportadorVeiculo_Id,
            protocoloTransportador_Id: item.protocoloTransportador[0].protocoloTransportador_Id,
            placa: data.placa,
            marca: data.marca,
            tipo: tipoVeiculo,
            capacidadeCarga: data.capacidadeCarga,
            tara: data.tara,
            anoFabricacao: data.anoFabricacao,
            numeroRenavam: data.renavam,
            dataVistoria: data.dataVistoria,
            dataValidadeVistoria: data.dataValidadeVistoria,
            arquivoRenavam: file_renavam != null ? file_renavam.name : null,
            arquivoRenavamBase64: file_renavam != null ? file_renavam.base64 : null,
            arquivoInspecaoInmetro: file_inmetro != null ? file_inmetro.name : null,
            arquivoInspecaoInmetroBase64: file_inmetro != null ? file_inmetro.base64 : null,
            arquivoComprovanteTara: file_comprovantetara != null ? file_comprovantetara.name : null,
            arquivoComprovanteTaraBase64: file_comprovantetara != null ? file_comprovantetara.base64 : null,
            arquivoComodato: file_comodato != null ? file_comodato.name : null,
            arquivoComodatoBase64: file_comodato != null ? file_comodato.base64 : null,
            status: veiculoStatus,
            usuarioUltimaAlteracao_Id: session != null && session.tipoAcesso == "AreaRestrita" ? session.usuario_Id : null,
            cor: data.cor,
            anoFabricacaoEquipamento: data.anoFabricacaoEquipamento,
            proprietarioOuLocado: proprietarioOuLocado,
            volume: data.volume,
            protocoloTransportadorVeiculoModalidades: protocoloTransportadorVeiculoModalidade
        }
        return json_submit;
    }
    const carregaJsonRequerimento = (data) => {
        let requerimentoTransportadorVeiculoModalidade = [];
        modalidades.map(m => {
            requerimentoTransportadorVeiculoModalidade.push({
                requerimentoTransportadorVeiculoModalidade_Id: 0,
                requerimentoTransportadorVeiculo_Id: rowEdit == null ? 0 : rowEdit.requerimentoTransportadorVeiculo_Id,
                modalidade: m.value
            });
        })

        let json_submit = {
            requerimentoTransportadorVeiculo_Id: rowEdit == null ? 0 : rowEdit.requerimentoTransportadorVeiculo_Id,
            requerimento_Id: item.requerimento_Id,
            placa: data.placa,
            placaAntiga: rowEdit != null ? rowEdit.placa : "",
            marca: data.marca,
            tipo: tipoVeiculo,
            capacidadeCarga: data.capacidadeCarga,
            tara: data.tara,
            anoFabricacao: data.anoFabricacao,
            numeroRenavam: data.renavam,
            arquivoRenavam: file_renavam ? file_renavam.name : null,
            arquivoRenavamBase64: file_renavam ? file_renavam.base64 : null,
            arquivoInspecaoInmetro: file_inmetro ? file_inmetro.name : null,
            arquivoInspecaoInmetroBase64: file_inmetro ? file_inmetro.base64 : null,
            arquivoComprovanteTara: file_comprovantetara ? file_comprovantetara.name : null,
            arquivoComprovanteTaraBase64: file_comprovantetara ? file_comprovantetara.base64 : null,
            arquivoComodato: file_comodato ? file_comodato.name : null,
            arquivoComodatoBase64: file_comodato ? file_comodato.base64 : null,
            status: "Ativo",
            usuarioUltimaAlteracao_Id: session != null && session.tipoAcesso == "AreaRestrita" ? session.usuario_Id : null,
            cor: data.cor,
            anoFabricacaoEquipamento: data.anoFabricacaoEquipamento,
            proprietarioOuLocado: proprietarioOuLocado,
            volume: data.volume,
            requerimentoTransportadorVeiculoModalidade: requerimentoTransportadorVeiculoModalidade
        }

        return json_submit;
    }
    const confirmaAddVeiculo = (result) => {
        setLoading(false);
        let _registro = registro;
        let veiculo = result.data;
        if (tipoCadastro == "Protocolo") {
            let new_list = [];
            veiculos.map(m => {
                if (m.protocoloTransportadorVeiculo_Id != veiculo.protocoloTransportadorVeiculo_Id)
                    new_list.push(m);
            });
            new_list.push(veiculo);
            set_veiculos(new_list);

            _registro.protocoloTransportadorVeiculo = new_list;
        }
        else if (tipoCadastro == "Requerimento") {
            let _veiculos = [
                ...veiculos
            ]

            if (item.setupSolicitacaoAcao.acao === "Alteração") {
                veiculo.Alteracao = true;
            }


            if (rowEdit == null) {
                _veiculos.push(veiculo)
                set_veiculos(_veiculos)
            } else {
                _veiculos[rowEdit.tableData.id] = veiculo;
                set_veiculos(_veiculos)
            }

            _registro.requerimentoTransportadorVeiculo = _veiculos;
        }
        set_registro(_registro);

        setValue("placa", "");
        setValue("marca", "");
        setValue("anoFabricacao", "");
        setValue("capacidadeCarga", "");
        setValue("tara", "");
        setValue("renavam", "");
        setValue("dataVistoria", "");
        setValue("dataValidadeVistoria", "");
        setValue("cor", "");
        setValue("anoFabricacaoEquipamento", "");
        set_proprietarioOuLocado(null);
        setValue("proprietarioOuLocado", null, false);
        setValue("volume", "");
        set_tipoVeiculo(null);
        set_modalidades([]);

        set_rowEdit(null);
        set_file_renavam(null);
        set_file_inmetro(null);
        set_file_comprovantetara(null);
        set_file_comodato(null);

        showMessage("Aviso", "Operação executada com sucesso", 'success', null);

    }

    const handleAvancar = () => {
        if ((session == null || (session && session.tipoAcesso == "Protocolo")) && veiculos.length == 0) {
            showMessage("Aviso", "Você não pode avançar sem informar os veículos", 'error', null);
            return;
        }

        if (tipoCadastro == "Requerimento") {
            setLoading(true);
            api_POST('requerimentoTransportador/ValidacaoVeiculoRequerimento/' + item.requerimento_Id)
                .then(result => handleProximoStep(registro))
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        } else {
            handleProximoStep(registro);
        }
    }


    const [optionsStatusVeiculo, setOptionsStatusVeiculo] = useState([
        { label: "Ativo", value: "Ativo" },
        { label: "Inativo", value: "Inativo" },
    ])

    return (
        <>
            <div>
                <Card className={`card card-stats`}>
                    <CardHeader>
                        <Row><Col md="12" className="text-right"><label className="text-danger">* Campos Obrigatórios</label></Col></Row>
                    </CardHeader>
                    <CardBody>
                        <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                            <h2 className="titulo-solicitacao">Veículos</h2>
                            <div className="formPrincipal">
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Row>
                                        <Col md={session != null && session.tipoAcesso == "AreaRestrita" && rowEdit != null ? "3" : "4"}>
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Placa</label></b>
                                                <Input type="text" name="placa" innerRef={register({ required: true })} onChange={handleChangePlaca} maxLength="8" />
                                                {errors.placa && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md={session != null && session.tipoAcesso == "AreaRestrita" && rowEdit != null ? "3" : "5"}>
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Marca/Modelo</label></b>
                                                <Input type="text" name="marca" maxLength="100" innerRef={register({ required: true })} />
                                                {errors.marca && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="3">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Ano Fabricação Chassi</label></b>
                                                <Input type="number" name="anoFabricacao" min={1950} max={9999} maxLength="4" innerRef={register({ required: true })} />
                                                {errors.anoFabricacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        {session != null && session.tipoAcesso == "AreaRestrita" && rowEdit &&
                                            <Col md="3">
                                                <FormGroup>
                                                    <b><label><span className="text-danger">*</span> Status</label></b>
                                                    <Select
                                                        options={optionsStatusVeiculo}
                                                        getOptionLabel={option => option.label}
                                                        getOptionValue={option => option.value}
                                                        name="status"
                                                        onChange={(e) => { handleStatusVeiculo(e.value) }}
                                                        value={optionsStatusVeiculo.filter(f => f.value == veiculoStatus)[0]}
                                                        placeholder="Selecione"
                                                        ref={e => register(
                                                            { name: "status" })
                                                        }
                                                    />
                                                    {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                        }
                                        <Col md="5">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Tipo </label></b>
                                                <Select
                                                    options={optionsTipoVeiculo}
                                                    getOptionLabel={option => option.label}
                                                    getOptionValue={option => option.value}
                                                    name="tipoVeiculo"
                                                    onChange={(e) => { handleTipoVeiculo(e.value) }}
                                                    value={optionsTipoVeiculo.filter(f => f.value == tipoVeiculo)}
                                                    placeholder="Selecione"
                                                    ref={e => register(
                                                        { name: "tipoVeiculo" },
                                                        { required: true })
                                                    }
                                                />
                                                {errors.tipoVeiculo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        {tipoCadastro == "Requerimento" && item.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RGG" &&
                                            <Col md="7" lg="7" >
                                                <FormGroup>
                                                    <b><label><span className="text-danger">* </span>Modalidades</label> </b>
                                                    <Select
                                                        options={optionsModalidades}
                                                        getOptionLabel={({ label }) => label}
                                                        getOptionValue={({ value }) => value}
                                                        name="modalidades"
                                                        isMulti={true}
                                                        value={optionsModalidades.filter(({ value }) => modalidades.filter(f => f.value == value).length > 0)}
                                                        onChange={(value) => handleModalidades(value || [])}
                                                        placeholder="Selecione"
                                                        ref={e => register(
                                                            { name: "modalidades" },
                                                            { required: false })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>}
                                        {tipoCadastro == "Protocolo" && item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla == "RGG" &&
                                            <Col md="7" lg="7" >
                                                <FormGroup>
                                                    <b><label><span className="text-danger">* </span>Modalidades</label> </b>
                                                    <Select
                                                        options={optionsModalidades}
                                                        getOptionLabel={({ label }) => label}
                                                        getOptionValue={({ value }) => value}
                                                        name="modalidades"
                                                        isMulti={true}
                                                        value={optionsModalidades.filter(({ value }) => modalidades.filter(f => f.value == value).length > 0)}
                                                        onChange={(value) => handleModalidades(value || [])}
                                                        placeholder="Selecione"
                                                        ref={e => register(
                                                            { name: "modalidades" },
                                                            { required: false })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>}
                                        <Col md="4">
                                            <FormGroup>
                                                <b><label>Ano Fabricação Equipamento <a href="#" id="questionAnoFabricacaoEquipamento"><i className="fas fa-question-circle"></i></a>
                                                    <UncontrolledTooltip target="questionAnoFabricacaoEquipamento" placement="top">Se o veículo não possuir equipamento, deixe o campo em branco</UncontrolledTooltip>
                                                </label></b>
                                                <Input type="number" name="anoFabricacaoEquipamento" min={1950} max={9999} maxLength="4" innerRef={register({ required: false })} />
                                            </FormGroup>
                                        </Col>
                                        <Col md="3">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Capacidade Carga</label></b>
                                                <Input type="number" name="capacidadeCarga" min={1} maxLength="5" innerRef={register({ required: true })} />
                                                {errors.capacidadeCarga && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="2">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Tara (kg)</label></b>
                                                <Input type="number" name="tara" innerRef={register({ required: true })} />
                                                {errors.anoFabricacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="3">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Renavam <a href="#" id="questionRenavam"><i className="fas fa-question-circle"></i></a>
                                                    <UncontrolledTooltip target="questionRenavam" placement="top">O Renavam é um número localizado no CRLV do veículo</UncontrolledTooltip>
                                                </label></b>
                                                <Input type="text" name="renavam" maxLength="20" innerRef={register({ required: true })} />
                                                {errors.renavam && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="3">
                                            <FormGroup>
                                                <b><label>Cor</label></b>
                                                <Input type="text" name="cor" maxLength="20" innerRef={register({ required: false })} />
                                            </FormGroup>
                                        </Col>
                                        <Col md="3">
                                            <FormGroup>
                                                <b><label>Proprietário/Alugado <a href="#" id="questionProprietarioAlugado"><i className="fas fa-question-circle"></i></a>
                                                    <UncontrolledTooltip target="questionProprietarioAlugado" placement="top">Informe se o veículo é de sua propriedade ou alugado</UncontrolledTooltip>
                                                </label></b>
                                                <Select
                                                    options={options_proprietarioOuLocado}
                                                    name="proprietarioOuLocado"
                                                    getOptionLabel={({ label }) => label}
                                                    getOptionValue={({ value }) => value}
                                                    onChange={(e) => { handleproprietarioOuLocado(e.value) }}
                                                    value={proprietarioOuLocado != null && options_proprietarioOuLocado.find(obj => obj.value === proprietarioOuLocado)}
                                                    placeholder="Selecione"
                                                    ref={e => register(
                                                        { name: "proprietarioOuLocado" },
                                                        { required: false })
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="3">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Volume (m³)</label></b>
                                                <Input
                                                    type="number"
                                                    id="volume"
                                                    step="0.1"
                                                    name="volume"
                                                    min={1}
                                                    maxLength="5"
                                                    innerRef={register({ required: true })} />
                                                <Tooltip
                                                    isOpen={tooltipOpen}
                                                    delay={{ show: 200, hide: 500 }}
                                                    target="volume"
                                                    placement="top"
                                                    toggle={() => setTooltipOpen(!tooltipOpen)}>
                                                    Informar o volume em M3 do equipamento do veículo, se houver
                                                </Tooltip>
                                                {errors.volume && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    {(tipoCadastro == "Protocolo" && session != null && session.tipoAcesso == "AreaRestrita") &&
                                        <Row>
                                            <Col md="3">
                                                <FormGroup>
                                                    <b><label>Vistoria</label></b>
                                                    <Input type="date" name="dataVistoria" innerRef={register({ required: true })} onBlur={handleDataVigencia} />
                                                    {errors.dataVistoria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                <FormGroup>
                                                    <b><label>Validade Vistoria</label></b>
                                                    <Input type="date" name="dataValidadeVistoria" innerRef={register({ required: true })} onBlur={handleDataVigencia} />
                                                    {errors.dataValidadeVistoria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    }
                                    <Row>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><p style={{ color: "#888" }}><span className="text-danger">*</span> Arquivo Renavam <a href="#" id="questionArquivoRenavam"><i className="fas fa-question-circle"></i></a>
                                                    <UncontrolledTooltip target="questionArquivoRenavam" placement="top">Arquivo CRLV do veículo</UncontrolledTooltip>
                                                </p></b>
                                                <InputPDF name="arquivoRenavam"
                                                    image={file_renavam}
                                                    height="3rem"
                                                    width="3rem"
                                                    documento_id={0} handlefile={handleFileRenavam}>
                                                </InputPDF>
                                            </FormGroup>
                                        </Col>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><p style={{ color: "#888" }}><span className="text-danger">*</span> Inspeção INMETRO</p></b>
                                                <InputPDF name="arquivoInmetro"
                                                    image={file_inmetro}
                                                    height="3rem"
                                                    width="3rem"
                                                    documento_id={0} handlefile={handleFileInmetro}>
                                                </InputPDF>
                                            </FormGroup>
                                        </Col>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><p style={{ color: "#888" }}>Comprovante de Tara</p></b>
                                                <InputPDF name="arquivoComprovanteTara"
                                                    image={file_comprovantetara}
                                                    height="3rem"
                                                    width="3rem"
                                                    documento_id={0} handlefile={handleFileComprovanteTara}>
                                                </InputPDF>
                                            </FormGroup>
                                        </Col>
                                        {loadInputComodato()}
                                        <Col lg="12" className="text-center">
                                            <FormGroup>
                                                <Button color="success" className="btn-mobile" type="submit"><i className="fas fa-save"></i>  Salvar Veículo</Button>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Form>
                                <Row>
                                    <Col md="12">
                                        <MaterialTable style={{ minHeight: "auto" }}
                                            title=""
                                            columns={[
                                                { title: 'Placa', field: 'placa' },
                                                { title: 'Marca', field: 'marca' },
                                                { title: 'Ano', field: 'anoFabricacao', type: 'numeric', cellStyle: { textAlign: "right" } },
                                                { title: 'Tipo', field: 'tipo' },
                                                { title: 'Tara', field: 'tara', type: 'numeric', cellStyle: { textAlign: "right" } },
                                                { title: 'Renavam', field: 'numeroRenavam' },
                                                { title: 'Status', field: 'status' },
                                                { title: 'Volume', field: 'volume' }
                                            ]}
                                            data={veiculos}
                                            isLoading={false}
                                            actions={actions}
                                            localization={table_translate}
                                            options={table_style}
                                        />
                                    </Col>

                                    {(tipoCadastro === "Requerimento" && item !== null && item.setupSolicitacaoAcao.acao === "Alteração") &&
                                        <Col lg="12" style={{ paddingTop: '20px' }}>
                                            <Card className="my-2" color="warning" inverse>
                                                <CardHeader>
                                                    <h3 style={{ margin: '0' }}>Atenção</h3>
                                                </CardHeader>
                                                <CardBody style={{ padding: '5px 15px 10px 15px' }}>
                                                    <CardText style={{ fontSize: 15, margin: '0 0 1rem 0' }}>
                                                        Caso clique no botão VOLTAR, para adicionar e/ou remover algum veículo, as alterações
                                                        já feitas nessa tela serão PERDIDAS!
                                                    </CardText>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    }

                                    <Col lg="6" className="text-left">
                                        {handleStepAnterior != null &&
                                            <Button color="secundary" onClick={() => handleStepAnterior(registro)} className="btn-mobile" type="submit"><i className="fas fa-chevron-left"></i> Voltar</Button>
                                        }
                                    </Col>
                                    <Col lg="6" className="text-right">
                                        {handleProximoStep != null &&
                                            <Button color="success" onClick={handleAvancar} className="btn-mobile" type="button">Próxima Etapa  <i className="fas fa-chevron-right"></i></Button>
                                        }
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}